import './chosen-bank-status.scss';

import { statusColors } from '@/constants';
import EditIcon from '@/media/icons/edit.svg?react';

import CircledImage from '../circled-image';

interface IProps {
  img: string | undefined;
  name: string | undefined;
  status: {
    code: string;
    name?: string;
  };
  size?: 'big';
  onEdit?: () => void;
  isLeasing?: boolean;
}

const ChosenBankStatus: React.FC<IProps> = ({
  img = '',
  name = '',
  status,
  size,
  onEdit,
  isLeasing
}) => {
  const isEditable = !!onEdit;

  const colors =
    statusColors[status.code as keyof typeof statusColors] ??
    statusColors.draft;

  return (
    <div
      className={`chosen-bank-status ${size ? `chosen-bank-status--${size}` : ''}`}
    >
      <CircledImage src={img} alt={name} />

      <div>
        <p className="chosen-bank-status__name">{name}</p>
        {status.code === 'chosen' ? (
          <p className="chosen-bank-status__description">
            {isLeasing ? 'Лизинг выбран' : 'Банк выбран'}
          </p>
        ) : (
          <div
            style={{
              color: colors.textColor,
              backgroundColor: colors.bgColor
            }}
            role={isEditable ? 'button' : undefined}
            className={`chosen-bank-status__mark ${isEditable ? 'chosen-bank-status__mark--editable' : ''}`}
            onClick={onEdit}
          >
            {status.name}
            {isEditable && <EditIcon />}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChosenBankStatus;
